import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Catalogs = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="catalogs-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.27329 4.39829C3.64836 4.02321 4.15707 3.8125 4.6875 3.8125H6.9375C7.42075 3.8125 7.8125 4.20425 7.8125 4.6875C7.8125 5.17075 7.42075 5.5625 6.9375 5.5625H4.6875C4.6212 5.5625 4.55761 5.58884 4.51072 5.63572C4.46384 5.68261 4.4375 5.7462 4.4375 5.8125V19.3125C4.4375 19.3788 4.46384 19.4424 4.51072 19.4893C4.55761 19.5362 4.6212 19.5625 4.6875 19.5625H19.3125C19.3788 19.5625 19.4424 19.5362 19.4893 19.4893C19.5362 19.4424 19.5625 19.3788 19.5625 19.3125V5.8125C19.5625 5.7462 19.5362 5.68261 19.4893 5.63572C19.4424 5.58884 19.3788 5.5625 19.3125 5.5625H11.4375C10.9543 5.5625 10.5625 5.17075 10.5625 4.6875C10.5625 4.20425 10.9543 3.8125 11.4375 3.8125H19.3125C19.8429 3.8125 20.3516 4.02321 20.7267 4.39829C21.1018 4.77336 21.3125 5.28206 21.3125 5.8125V19.3125C21.3125 19.8429 21.1018 20.3516 20.7267 20.7267C20.3516 21.1018 19.8429 21.3125 19.3125 21.3125H4.6875C4.15706 21.3125 3.64836 21.1018 3.27329 20.7267C2.89821 20.3516 2.6875 19.8429 2.6875 19.3125V5.8125C2.6875 5.28207 2.89821 4.77336 3.27329 4.39829Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.0625 17.0625C6.0625 16.5793 6.45425 16.1875 6.9375 16.1875H14.8125C15.2957 16.1875 15.6875 16.5793 15.6875 17.0625C15.6875 17.5457 15.2957 17.9375 14.8125 17.9375H6.9375C6.45425 17.9375 6.0625 17.5457 6.0625 17.0625Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.0625 13.6875C6.0625 13.2043 6.45425 12.8125 6.9375 12.8125H17.0625C17.5457 12.8125 17.9375 13.2043 17.9375 13.6875C17.9375 14.1707 17.5457 14.5625 17.0625 14.5625H6.9375C6.45425 14.5625 6.0625 14.1707 6.0625 13.6875Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8125 10.3125C12.8125 9.82925 13.2043 9.4375 13.6875 9.4375H17.0625C17.5457 9.4375 17.9375 9.82925 17.9375 10.3125C17.9375 10.7957 17.5457 11.1875 17.0625 11.1875H13.6875C13.2043 11.1875 12.8125 10.7957 12.8125 10.3125Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.0625 4.3125C6.0625 3.41504 6.79004 2.6875 7.6875 2.6875H10.6875C11.585 2.6875 12.3125 3.41504 12.3125 4.3125V11.4383C12.3125 11.7698 12.1251 12.0729 11.8284 12.2211C11.5318 12.3692 11.1769 12.337 10.9118 12.1378L9.1875 10.842L7.46316 12.1378C7.19808 12.337 6.84319 12.3692 6.54656 12.2211C6.24992 12.0729 6.0625 11.7698 6.0625 11.4383V4.3125ZM7.8125 4.4375V9.6862L8.66184 9.04794C8.97322 8.81395 9.40178 8.81395 9.71316 9.04794L10.5625 9.6862V4.4375H7.8125Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
